<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">
    <!-- Header -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ลงทะเบียนสมาชิก
                (Register Parking)</h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
                จัดการคำขอลงทะเบียนสมาชิกและประวัติการชำระเงิน</p>
            <p *ngIf="clientScope.isRestricted()" class="text-xs text-amber-700 dark:text-amber-400 mt-2 flex items-center gap-1">
                <span class="material-icons text-sm">store</span>
                แสดงเฉพาะร้าน: <span class="font-bold">{{ clientScope.scopeSummaryLabel() }}</span>
            </p>
        </div>
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
            <!-- Date Filter (same pattern as transaction-parking) -->
            <div
                class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-50 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
                <span class="material-icons text-slate-400 dark:text-slate-500 text-xl">calendar_today</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
                    </div>
                    <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate"
                        (click)="startDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
                </div>

                <span class="text-slate-300 dark:text-slate-600">-</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
                    </div>
                    <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
                        (click)="endDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
                </div>
            </div>

            <button (click)="navigateToCreate()"
                class="px-5 py-3 bg-amber-400 dark:bg-amber-500 text-white rounded-xl shadow-lg shadow-amber-200 dark:shadow-none hover:bg-amber-500 dark:hover:bg-amber-600 hover:-translate-y-1 transition-all duration-300 font-bold flex items-center gap-2">
                <span class="material-icons">add_circle</span>
                <span>สร้างรายการ</span>
            </button>

            <button (click)="toggleDashboard()"
                class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
                [title]="showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ'">
                <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
                <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ' }}</span>
            </button>

            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
        </div>
    </div>

    <!-- Collapsible Dashboard Section -->
    <div class="overflow-hidden transition-all duration-500 ease-in-out"
        [style.max-height]="showDashboard ? '3000px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
        [style.margin-bottom]="showDashboard ? '2rem' : '0'">

        <!-- Stats Cards (follow global date filter) -->
        <div class="flex items-center justify-between mb-4">
            <p class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                สรุปตามช่วงวันที่: <span class="text-slate-600 dark:text-slate-300">{{ tableDateRangeLabel }}</span>
            </p>
        </div>
        <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div *ngFor="let stat of dashboardStats; let i = index"
                class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
                [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

                <!-- Background Icon Decoration -->
                <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
                    [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                        [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                        <span class="material-icons text-2xl">{{ stat.icon }}</span>
                    </div>
                </div>

                <div class="relative z-10">
                    <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                    </h4>
                    <h4 *ngIf="stat.subtitle"
                        class="text-slate-400 opacity-60 text-xs font uppercase tracking-wider mb-1 truncate">{{
                        stat.subtitle }}
                    </h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            <!-- Chart Section -->
            <div class="animate-fade-in lg:col-span-2 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 p-6 pb-10 relative overflow-hidden"
                style="animation-delay: 0.1s;">
                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
                            แนวโน้มการลงทะเบียน
                            <span
                                class="text-sm font-medium text-slate-500 dark:text-slate-400 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                                {{ chartTotalCount }} รายการ
                            </span>
                        </h3>
                        <p class="text-xs text-slate-400 dark:text-slate-500 mt-1">กรองช่วงเวลาแยกจากวันที่ด้านบน</p>
                        <div class="flex items-center gap-4 text-xs font-medium mt-1">
                            <span class="flex items-center gap-1 "><span
                                    class="w-2 h-2 rounded-full bg-amber-400"></span>
                                <span class="text-slate-600 dark:text-slate-400">{{ chartMode === 'daily' ? 'รายวัน' :
                                    'รายเดือน' }}</span>
                                <span class="text-slate-400 dark:text-slate-500">
                                    @if(chartMode === 'daily' && dailySubMode === 'default') {
                                    ( 7 วันย้อนหลัง )
                                    }
                                    @if(chartMode === 'daily' && dailySubMode === 'custom') {
                                    ( สูงสุด 10 วัน)
                                    }
                                    @if(chartMode === 'monthly') {
                                    ( {{ selectedMonthStart | date: 'MM/yyyy' }} - {{ selectedMonthEnd | date: 'MM/yyyy'
                                    }}
                                    )
                                    } </span>
                            </span>
                        </div>
                    </div>

                    <!-- Chart Controls -->
                    <div class="flex flex-col items-end gap-2">

                        <!-- Row 1: Inputs & Sub-Modes -->
                        <div class="flex items-center gap-2 min-h-[34px]">

                            <!-- Daily Controls -->
                            <div *ngIf="chartMode === 'daily'" class="flex items-center gap-2">
                                <div
                                    class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1">
                                    <button (click)="setDailySubMode('default')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'default' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300'">
                                        ทั้งหมด
                                    </button>
                                    <button (click)="setDailySubMode('custom')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'custom' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300'">
                                        กำหนดเอง
                                    </button>
                                </div>

                                <div *ngIf="dailySubMode === 'custom'"
                                    class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                    <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()"
                                        [max]="customEndDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24 [color-scheme:light] dark:[color-scheme:dark]">
                                    <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                                    <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()"
                                        [min]="customStartDate" [max]="maxCustomDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24 [color-scheme:light] dark:[color-scheme:dark]">

                                    <button (click)="resetCustomDate()"
                                        class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 dark:text-slate-500 hover:text-amber-500 transition-colors"
                                        title="รีเซ็ตเป็น 10 วันล่าสุด">
                                        <span class="material-icons text-[16px]">refresh</span>
                                    </button>
                                </div>
                            </div>

                            <!-- Monthly Inputs -->
                            <div *ngIf="chartMode === 'monthly'"
                                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] [color-scheme:light] dark:[color-scheme:dark]">
                                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                                <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] [color-scheme:light] dark:[color-scheme:dark]">
                            </div>

                        </div>

                        <!-- Row 2: Toggles -->
                        <div class="flex items-center gap-2">
                            <!-- Type Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartType('line')"
                                    [class]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Line Chart">
                                    <span class="material-icons text-sm">show_chart</span>
                                </button>
                                <button (click)="setChartType('bar')"
                                    [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Bar Chart">
                                    <span class="material-icons text-sm">bar_chart</span>
                                </button>
                            </div>

                            <!-- Mode Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartMode('daily')"
                                    [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายวัน</button>
                                <button (click)="setChartMode('monthly')"
                                    [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายเดือน</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="relative h-64 w-full">
                    <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
                        <defs>
                            <linearGradient id="gradientArea" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
                            </linearGradient>
                        </defs>

                        <!-- Grid Lines -->
                        <g class="text-slate-200">
                            <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
                            <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="0" x2="100" y2="0" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                        </g>

                        <!-- Prev Month Line removed since dynamic mode doesn't support it simply yet -->

                        <!-- Current Area & Line -->
                        <!-- Line Chart -->
                        <g *ngIf="chartType === 'line'">
                            <polygon [attr.points]="currentMonthAreaPoints" fill="url(#gradientArea)"
                                class="opacity-50 transition-all duration-500" />
                            <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="0.5"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="drop-shadow-sm transition-all duration-500" />

                            <!-- Dots (Hover effect) -->
                            <circle *ngFor="let point of currentMonthDots" [attr.cx]="point.x" [attr.cy]="point.y"
                                r="1.5" fill="#fff" stroke="#fbbf24" stroke-width="1"
                                class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </circle>
                        </g>

                        <!-- Bar Chart -->
                        <g *ngIf="chartType === 'bar'">
                            <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 2" [attr.y]="point.y"
                                width="4" [attr.height]="100 - point.y" [attr.fill]="point.color"
                                class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white transition-all duration-300 cursor-pointer rx-[1px]">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </rect>
                        </g>
                    </svg>

                    <!-- Y-Axis Labels (Left Side) -->
                    <div
                        class="absolute inset-y-0 left-[-30px] bottom-2 w-8 flex flex-col justify-between text-[9px] text-yellow-400 font-medium pointer-events-none py-0 items-end pr-1">
                        <!-- Reverse order to match bottom-up (0 at bottom) but flex-col goes top-down.
                         So 100% is top, 0% is bottom.
                         yAxisLabels is [0, 25, 50, 75, 100].
                         We need to display: 100, 75, 50, 25, 0
                    -->
                        <span>{{ yAxisLabels[4] }}</span>
                        <span>{{ yAxisLabels[3] }}</span>
                        <span>{{ yAxisLabels[2] }}</span>
                        <span>{{ yAxisLabels[1] }}</span>
                        <span class="translate-y-2">{{ yAxisLabels[0] }}</span>
                        <!-- 0 needs slight adjust to align with bottom line -->
                    </div>

                    <!-- Dynamic Labels -->
                    <div class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none">
                        <ng-container *ngFor="let dot of currentMonthDots; let i = index">
                            <!-- Smart Label Visibility: Show every 5th label, plus first and last. If few points (< 15), show all. -->
                            <div *ngIf="(currentMonthDots.length <= 15) || (i % 5 === 0) || i === 0 || i === currentMonthDots.length - 1"
                                class="absolute top-0 flex flex-col items-center whitespace-nowrap"
                                [style.left.%]="dot.x" style="transform: translateX(-50%);">
                                <span class="text-[10px] text-slate-400 font-medium">{{ dot.label }}</span>
                                <span *ngIf="dot.subLabel" class="text-[9px] text-slate-400">{{ dot.subLabel }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Recent Activity (follow global date filter) -->
            <div class="animate-fade-in lg:col-span-1 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-8"
                style="animation-delay: 0.15s;">
                <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-1">รายการล่าสุด</h3>
                <p class="text-xs text-slate-400 dark:text-slate-500 mb-6">5 รายการล่าสุด · {{ tableDateRangeLabel }}</p>
                <div class="relative">
                    <div class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
                    <div class="space-y-6 relative">
                        <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
                            <div class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-bold shadow-md ring-4 ring-white dark:ring-slate-800 z-10"
                                [ngClass]="item.color">
                                {{ item.initial }}
                            </div>
                            <div class="flex-1 pt-1">
                                <div class="flex justify-between items-start">
                                    <h5
                                        class="text-sm font-bold text-slate-800 dark:text-slate-200 group-hover:text-amber-500 transition-colors">
                                        {{ item.name }}</h5>
                                    <span
                                        class="text-[10px] font-semibold text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-600 whitespace-nowrap">{{
                                        item.timeAgo }}</span>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.info }}</p>
                            </div>
                        </div>
                        <div *ngIf="recentActivity.length === 0"
                            class="text-center text-slate-400 dark:text-slate-500 py-10">
                            <span class="material-icons text-3xl mb-2 opacity-50">history</span>
                            <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Collapsible Dashboard Section -->

    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay: 0.2s;">

        <div
            class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">receipt_long</span>
                รายการใบแจ้งหนี้
            </h3>
            <!-- Custom Search Type & Input Group -->
            <div class="flex flex-col md:flex-row gap-3 w-full md:flex-1 md:min-w-0 md:justify-end">

                <!-- Status Filter Group -->
                <div
                    class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm">
                    <button (click)="selectStatus(2)"
                        [class]="filterStatus === 2 ? 'bg-white dark:bg-slate-700 text-green-600 dark:text-green-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-green-600 dark:hover:text-green-400'"
                        class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
                        ยืนยันแล้ว
                    </button>
                    <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
                    <button (click)="selectStatus(1)"
                        [class]="filterStatus === 1 ? 'bg-white dark:bg-slate-700 text-yellow-600 dark:text-yellow-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-yellow-600 dark:hover:text-yellow-400'"
                        class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
                        ฉบับร่าง
                    </button>
                    <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
                    <button (click)="selectStatus(3)"
                        [class]="filterStatus === 3 ? 'bg-white dark:bg-slate-700 text-rose-600 dark:text-rose-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-rose-600 dark:hover:text-rose-400'"
                        class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 ease-in-out">
                        ยกเลิก
                    </button>
                </div>


                <!-- Client Filter -->
                <div *ngIf="clientOptions.length > 0" class="relative w-[200px] shrink-0">
                    <select [(ngModel)]="filterClientId" (ngModelChange)="onClientFilterChange()"
                        [disabled]="isClientFilterLocked"
                        class="w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl text-sm font-medium text-slate-600 dark:text-slate-300 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 transition-all outline-none h-[46px] disabled:opacity-70 disabled:cursor-not-allowed">
                        <option [ngValue]="0">ทุก Client</option>
                        <option *ngFor="let c of clientOptions" [ngValue]="c.id">{{ c.name }}</option>
                    </select>
                </div>

                <!-- Min Fee Input -->
                <div class="relative w-[150px]">
                    <span
                        class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 font-bold text-xs">฿</span>
                    <input type="number" placeholder="จำนวนขั้นต่ำ" [(ngModel)]="minFee"
                        (ngModelChange)="onMinFeeChange()"
                        class="w-full pl-7 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl text-sm font-medium text-slate-600 dark:text-slate-300 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 transition-all placeholder:text-slate-400 dark:placeholder:text-slate-600 outline-none h-[46px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
                </div>

                <div
                    class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full md:flex-1 md:min-w-[380px] relative z-30">

                    <!-- Search Type Dropdown -->
                    <div class="relative min-w-[120px] shrink-0 border-r border-slate-200 dark:border-slate-700">
                        <button (click)="toggleSearchTypeDropdown()"
                            class="w-full pl-4 pr-3 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none">
                            <span>{{ currentSearchTypeLabel }}</span>
                            <span
                                class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200"
                                [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
                        </button>

                        <!-- Backdrop -->
                        <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
                            (click)="toggleSearchTypeDropdown()"></button>

                        <!-- Dropdown Menu -->
                        <div *ngIf="isSearchTypeDropdownOpen"
                            class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animation-fade-in-up">
                            <button (click)="selectSearchType('customerName')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">person</span>
                                ชื่อลูกค้า
                            </button>
                            <button (click)="selectSearchType('name')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">label</span>
                                ชื่อรายการ
                            </button>
                            <button (click)="selectSearchType('invoiceNo')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">receipt</span>
                                เลขที่ใบแจ้งหนี้
                            </button>
                            <button (click)="selectSearchType('description')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                <span
                                    class="material-icons text-lg text-slate-400 dark:text-slate-500">description</span>
                                หมายเหตุ
                            </button>
                            <button (click)="selectSearchType('clientName')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">store</span>
                                บริษัทผู้เช่า
                            </button>
                        </div>
                    </div>

                    <!-- Search Input -->
                    <div class="relative flex-1">
                        <span
                            class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                        <input type="text"
                            [placeholder]="searchType === 'customerName' ? 'ค้นหาชื่อลูกค้า...' : (searchType === 'name' ? 'ค้นหาชื่อรายการ...' : (searchType === 'description' ? 'ค้นหาหมายเหตุ...' : 'ค้นหาเลขที่ใบแจ้งหนี้...'))"
                            [(ngModel)]="searchText" (keyup.enter)="onSearch()"
                            class="w-full pl-10 pr-4 py-2.5 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600 rounded-r-xl">
                    </div>
                    <button (click)="onSearch()"
                        class="shrink-0 px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all h-[46px]">
                        ค้นหา
                    </button>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto h-[600px] relative custom-scrollbar">
            <table class="w-full text-left border-collapse">
                <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
                    <tr>
                        <!-- <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            ชื่อรายการ
                        </th> -->
                        <!-- <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            Client
                        </th> -->
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            ชื่อลูกค้า
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            เลขที่ใบแจ้งหนี้
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-right whitespace-nowrap">
                            ค่าธรรมเนียม
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            หมายเหตุ
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                            วันที่สร้าง
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center whitespace-nowrap">
                            สถานะ
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
                            จัดการ
                        </th>
                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let c of filteredAndPaginatedData; let i = index"
                        (click)="openDetailModal(c.id)"
                        class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200 cursor-pointer"
                        [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">

                        <!-- <td
                            class="p-5 text-sm font-bold text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors whitespace-nowrap">
                            {{ c.name || '-' }}
                        </td> -->

                        <!-- <td class="p-5 whitespace-nowrap text-sm text-slate-600 dark:text-slate-300 font-medium">
                            {{ c.clientName || '-' }}
                        </td> -->

                        <td class="p-5 whitespace-nowrap">
                            <div class="flex items-center gap-3">
                                <div
                                    class="flex-shrink-0 w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-slate-500 dark:text-slate-400 font-bold text-xs shadow-sm group-hover:bg-white dark:group-hover:bg-slate-800 group-hover:text-amber-500 dark:group-hover:text-amber-400 transition-colors">
                                    {{ c.customerName ? c.customerName.charAt(0) : '?' }}
                                </div>
                                <div class="flex flex-col">
                                    <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ c.customerName
                                        || 'ไม่มีชื่อ'
                                        }}</span>
                                    <span class="text-xs text-slate-400 dark:text-slate-500 font-mono"
                                        *ngIf="c.cpCustomerId">{{
                                        c.cpCustomerId }}</span>
                                </div>
                            </div>
                        </td>

                        <td class="p-5 font-mono text-sm text-slate-600 dark:text-slate-300 font-medium ">
                            {{ c.invoiceNo || '-' }}
                        </td>

                        <td class="p-5 text-right font-bold text-slate-700 dark:text-slate-200">
                            {{ (c.fee | number) || '0' }}
                        </td>

                        <td class="p-5 text-slate-400 dark:text-slate-500 text-xs italic max-w-xs truncate">
                            {{ c.description || '-' }}
                        </td>

                        <td class="p-5 whitespace-nowrap text-sm text-slate-500 dark:text-slate-400 font-medium">
                            {{ c.createDate | date:'dd/MM/yyyy HH:mm' }}
                        </td>

                        <td class="p-5 text-center">
                            <span
                                class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                                [ngClass]="{
                                'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800': c.status === 1,
                                'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800': c.status === 2,
                                'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800': c.status === 3
                            }">
                                <span class="w-1.5 h-1.5 rounded-full mr-1.5"
                                    [ngClass]="{
                                    'bg-yellow-500': c.status === 1,
                                    'bg-green-500': c.status === 2,
                                    'bg-rose-500': c.status === 3
                                }"></span>
                                {{ c.status === 1 ? 'ฉบับร่าง' : c.status === 2 ? 'ยืนยันแล้ว' : c.status === 3 ? 'ยกเลิก' : 'ไม่ระบุ' }}
                            </span>
                        </td>

                        <td class="p-5 text-center whitespace-nowrap">
                            <div class="flex items-center justify-center gap-2">
                                <button *ngIf="c.status === 1" (click)="$event.stopPropagation(); openEditForm(c.id)"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-amber-500 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 hover:bg-amber-500 dark:hover:bg-amber-600 hover:text-white transition-all shadow-sm hover:shadow-amber-200 dark:hover:shadow-amber-900/50"
                                    title="แก้ไขฉบับร่าง">
                                    <span class="material-icons text-[18px]">edit</span>
                                </button>

                                <button *ngIf="c.status === 1" (click)="$event.stopPropagation(); openDetailModal(c.id)"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-green-500 dark:text-green-400 bg-green-50 dark:bg-green-900/30 hover:bg-green-500 dark:hover:bg-green-600 hover:text-white transition-all shadow-sm hover:shadow-green-200 dark:hover:shadow-green-900/50"
                                    title="ยืนยัน">
                                    <span class="material-icons text-[18px]">how_to_reg</span>
                                </button>

                                <button *ngIf="c.status === 2" (click)="printRegisterParkingPdf(c.id, $event)"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-red-500 dark:text-red-400 bg-red-50 dark:bg-red-900/30 hover:bg-red-500 dark:hover:bg-red-600 hover:text-white transition-all shadow-sm hover:shadow-red-200 dark:hover:shadow-red-900/50"
                                    title="พิมพ์ PDF">
                                    <span class="material-icons text-[18px]">picture_as_pdf</span>
                                </button>

                                <button *ngIf="c.status === 2 || c.status === 3" (click)="$event.stopPropagation(); openDetailModal(c.id)"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 dark:hover:bg-blue-600 hover:text-white transition-all shadow-sm hover:shadow-blue-200 dark:hover:shadow-blue-900/50"
                                    title="ดูข้อมูล">
                                    <span class="material-icons text-[18px]">visibility</span>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="filteredAndPaginatedData.length === 0">
                        <td [attr.colspan]="9" class="py-20 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div
                                    class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                                    <span
                                        class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                                </div>
                                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูล</h3>
                                <span
                                    class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="p-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">

            <!-- Pagination Footer -->
            <div
                class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 w-full">
                <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
                    <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }}
                        รายการ</span>
                    <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                        class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                    </select>
                </div>

                <div class="flex items-center gap-2">
                    <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                        class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
                        <span class="material-icons text-sm">chevron_left</span>
                    </button>

                    <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                        class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
                        [ngClass]="page === currentPage ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'">
                        {{ page }}
                    </button>

                    <button (click)="setPage(currentPage + 1)"
                        [disabled]="currentPage === totalPages || totalPages === 0"
                        class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
                        <span class="material-icons text-sm">chevron_right</span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>


<app-modal-register-parking-detail *ngIf="isModalDetailOpen" [id]="selectedRegisterParkingId"
    (close)="closeDetailModal()" (save)="saveDetailModal()">
</app-modal-register-parking-detail>

<app-modal-register-parking-form *ngIf="isFormModalOpen" [siteId]="selectedSiteId" [menuId]="menuId"
    [groupId]="editGroupId" (close)="closeFormModal()" (saved)="onFormSaved()">
</app-modal-register-parking-form>

<app-modal-invoice-pdf-viewer
    *ngIf="showPdfModal"
    [pdfSrc]="pdfSrc"
    [modalTitle]="'รายงานรายละเอียดทะเบียนสมาชิก (PDF Preview)'"
    [downloadFileName]="'register-parking-' + pdfRegisterGroupId + '.pdf'"
    (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
<app-pss-loading *ngIf="isProcessingPdf" text="กำลังโหลดไฟล์ PDF" detail="โปรดรอสักครู่ . . ."></app-pss-loading>
